export const ACCOUNT_CARDS_FETCH_START = 'ACCOUNT_CARDS_FETCH_START';
export const ACCOUNT_CARDS_FETCH_FAIL = 'ACCOUNT_CARDS_FETCH_FAIL';
export const ACCOUNT_CARDS_FETCH_SUCCESS = 'ACCOUNT_CARDS_FETCH_SUCCESS';

export const ACCOUNT_CARDS_DELETE_START = 'ACCOUNT_CARDS_DELETE_START';
export const ACCOUNT_CARDS_DELETE_FAIL = 'ACCOUNT_CARDS_DELETE_FAIL';
export const ACCOUNT_CARDS_DELETE_SUCCESS = 'ACCOUNT_CARDS_DELETE_SUCCESS';

export const ACCOUNT_CARDS_MAKE_DEFAULT_START = 'ACCOUNT_CARDS_MAKE_DEFAULT_START';
export const ACCOUNT_CARDS_MAKE_DEFAULT_FAIL = 'ACCOUNT_CARDS_MAKE_DEFAULT_FAIL';
export const ACCOUNT_CARDS_MAKE_DEFAULT_SUCCESS = 'ACCOUNT_CARDS_MAKE_DEFAULT_SUCCESS';
